/**
 * Returns the JWT expiration as an epoch timestamp in milliseconds.
 *
 * This only decodes the public payload so the UI can schedule its logout. Token
 * authenticity and expiration are always enforced by the backend.
 */
export function getJwtExpiration(token: string): number | null {
  try {
    const payloadPart = token.split('.')[1];
    if (!payloadPart) return null;

    const base64Payload = payloadPart.replace(/-/g, '+').replace(/_/g, '/');
    const normalizedPayload = base64Payload.padEnd(Math.ceil(base64Payload.length / 4) * 4, '=');
    const payload = JSON.parse(atob(normalizedPayload)) as { exp?: unknown };
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}
